/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUserSettingsResponse } from '../../models/update-user-settings-response';
import { UserServiceUpdateUserSettingsRequest } from '../../models/user-service-update-user-settings-request';

export interface UserServiceUpdateUserSettings$Params {
  userUuid: string;
      body: UserServiceUpdateUserSettingsRequest
}

export function userServiceUpdateUserSettings(http: HttpClient, rootUrl: string, params: UserServiceUpdateUserSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateUserSettingsResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceUpdateUserSettings.PATH, 'put');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateUserSettingsResponse>;
    })
  );
}

userServiceUpdateUserSettings.PATH = '/api/v3/gateway/user/{userUuid}/settings';
